export default "__VITE_ASSET__8eb8274a__"